import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IndividualLicenseComponent } from './individual-license/individual-license.component';
import { EntityLicenseComponent } from './entity-license/entity-license.component';

const routes: Routes = [
  {
    path: 'individual-license',
    component: IndividualLicenseComponent
  },
  {
    path: 'entity-license',
    component: EntityLicenseComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LicenseRoutingModule { }
